import React from 'react'
import {compose} from 'ramda'
import {translate} from '@modifi/plugin-i18n'
import {TaskStatus} from '@modifi/enums'

import StatusFilter, {StatusFilterProps} from './StatusFilter'
import {FilterOption} from '../../ui/filter'
import {TranslateFn} from '../../types/i18n'

const getOptions = (t: TranslateFn): FilterOption[] => [
  {
    label: t('task-status.todo'),
    value: TaskStatus.TODO,
  },
  {
    label: t('task-status.in-review'),
    value: TaskStatus.IN_REVIEW,
  },
  {
    label: t('task-status.resolved'),
    value: TaskStatus.RESOLVED,
  },
]

type TaskStatusFilterProps = Omit<StatusFilterProps, 'filterKey' | 'options'> & {
  t: TranslateFn
}

const TaskStatusFilter: React.FC<TaskStatusFilterProps> = ({t, ...restFilterProps}) => (
  <StatusFilter filterKey="filter.status" options={getOptions(t)} {...restFilterProps} />
)

export default compose(translate('shared'))(TaskStatusFilter)
